import "./OurServices.module.css";
import MainNavigation from "@/reusable_sections/Header";
import AdvancedDataAnalytics from "./sections/AdvancedDataAnalytics";
import IntelligentDataAutomation from "./sections/IntelligentDataAutomation";
import AdHocTechnicalServices from "./sections/AdHocTechnicalServices";
import CorporateFooter from "@/reusable_sections/Footer";
export default function OurServicesPage() {
  return <div>
      <MainNavigation />
      <AdvancedDataAnalytics />
      <IntelligentDataAutomation />
      <AdHocTechnicalServices />
      <CorporateFooter />
    </div>;
}